(function ($) {
  $.fn.ajaxPopulate = function (options) {
    var self = this;
    var deferred = $.Deferred();

    var defaults = {
      method: 'GET'
    };

    var settings = $.extend(true, {}, defaults, options);

    $.ajax({
      type: settings.method,
      data: settings.data,
      url: settings.url,
      success: function (data) {
        $(self).find(settings.target_selector).html(data);
        deferred.resolve();
      },
      error: function() {
        deferred.reject('AJAX request failed.');
      }
    });

    return deferred.promise();
  };
}(jQuery));